export default "__VITE_ASSET__CWW4yQ5P__";